<template>
	<div id="app">
		<el-container>
			<el-header class="div-header">
				<Header />
				<el-divider class="header-divider"></el-divider>
			</el-header>

			<div class="main-div">
				<el-container class="main-div parentDiv">
					<splitpanes class="default-theme defaultStyle custom-splite">
						<pane size="100" class="SideBarLeft">
               <!--SID009 Body Part -->
							<template>
							<!-- Dialog body content section -->
                              <!--First Dialog body section -->
                                <section>
                                    <el-dialog
                                        title=""
                                        :visible.sync="dialogVisible "
                                        close="false"
                                        :close-on-click-modal="false"
                                        class="SID0009_DilaogDiv"
                                        >
                                        <el-container>
                                            <div class="SID0009__popupScreen">
                                                <div class="titleFirstDialog">
                                                    <span >原文利用上限値を超えている場合</span>
                                                </div>
                                                <div class="firstSpan">
                                                    <span>ご利用のユーザーは原文利用数が上限値を超えているため、本文テキストと表示することはできません。</span>
                                                </div>
                                                <div class="secondSpan">
                                                    <span>上限値を変更したい場合は、システム管理者にご連絡下さい。</span>
                                                </div>  
                                                <div class="ButtonClose">
                                                    <el-button type="info" plain>閉じる</el-button>
                                                </div>
                                            </div>
                                    </el-container>
                                    </el-dialog>
                                </section>
                                <!--Second Dialog body section -->
                                 <section>
                                    <el-dialog
                                        title=""
                                        :visible.sync="dialogVisible2 "
                                        close="false"
                                        :close-on-click-modal="false"
                                        class="SID0009_DilaogDiv2"
                                        >
                                        <el-container>
                                            <div class="SID0009__popupScreen2">
                                                <div class="titleFirstDialog2">
                                                    <span >ユーザーに権限がない場合</span>
                                                </div>
                                                <div class="FirstSpan2">
                                                    <span>ご利用のユーザーは本文テキストを表示できません。</span>
                                                </div>  
                                                <div class="ButtonClose2">
                                                    <el-button type="info" plain>閉じる</el-button>
                                                </div>
                                            </div>
                                    </el-container>
                                    </el-dialog>
                                </section>
                                <!--Third Dialog body section -->
                                 <section>
                                    <el-dialog
                                        title=""
                                        :visible.sync="dialogVisible3 "
                                        close="false"
                                        :close-on-click-modal="false"
                                        class="SID0009_DilaogDiv3"
                                        >
                                        <el-container>
                                            <div class="SID0009__popupScreen3">
                                                <div class="titleFirstDialog3">
                                                    <span >書誌データが存在しない場合、または本文テキスト提供不可フラグが立っている場合</span>
                                                </div>
                                                <div class="FirstSpan3">
                                                    <span>要求された記事は本文テキストを表示できません。</span>
                                                </div>  
                                                <div class="ButtonClose3">
                                                    <el-button type="info" plain>閉じる</el-button>
                                                </div>
                                            </div>
                                    </el-container>
                                    </el-dialog>
                                </section>
							</template>
              <!--SID0009 Body Part End-->
						</pane>
						<pane class="SideBarRight">
							<SideBar class="SidePane" />
						</pane>
					</splitpanes>
				</el-container>
			</div>

			<el-container class="footer-div">
				<el-footer class="footer-element">
					<FooterComponent />
				</el-footer>
			</el-container>
		</el-container>
	</div>
</template>

<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

export default {
	name: "PopupScreen",
	components: {
		Header,
		SideBar,
		FooterComponent,
		Splitpanes,
		Pane
	},
	data() {
		return {			
            dialogVisible: true,
            dialogVisible2: true,
            dialogVisible3: true           
		};
    },
    created() {
        //For the screen Title
     document.title = "記事閲覧";
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
        this.$router.push('/sp/0009');
    }
    else{
        this.$router.push('/0009');
    }
     },  
    beforeCreate(){
      //Common.Session.CheckSessionExists_IfExpired_GoToLogout();
    },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "0009.css";
</style>